import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import config from "../config";
import "./admin.css";

const API = config.API_BASE_URL;

export const AdminMeContext = createContext(null);
export const useAdminMe = () => useContext(AdminMeContext);

export default function AdminShell({ children }) {
  const { t } = useTranslation();
  const [me, setMe] = useState(null);
  const [err, setErr] = useState(null);

  const loadMe = useCallback(() => {
    axios
      .get(`${API}/admin/me`)
      .then((r) => { setMe(r.data); setErr(null); })
      .catch((e) => {
        const s = e?.response?.status;
        setErr(s === 401 || s === 403 ? "forbidden" : "error");
      });
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  if (err === "forbidden")
    return (
      <div className="ad-wrap">
        <div className="ad-banner err">{t("You do not have access to the administration area.")}</div>
      </div>
    );
  if (err)
    return (
      <div className="ad-wrap">
        <div className="ad-banner err">{t("Something went wrong — please try again.")}</div>
      </div>
    );
  if (!me) return <div className="ad-wrap"><div className="ad-empty">…</div></div>;

  return (
    <AdminMeContext.Provider value={{ me, reload: loadMe }}>
      <div className="ad-wrap">
        {/* Οι καρτέλες της διαχείρισης εμφανίζονται στη γραμμή του μενού
            (Navbar) όσο ο χρήστης βρίσκεται μέσα στο /admin. */}
        {children}
      </div>
    </AdminMeContext.Provider>
  );
}

export const eur = (n) =>
  n == null ? "—" : Number(n).toLocaleString("el-GR", { style: "currency", currency: "EUR" });

export const dt = (s) => (s ? new Date(s).toLocaleString("el-GR", { dateStyle: "short", timeStyle: "short" }) : "—");
export const d8 = (s) => (s ? new Date(s).toLocaleDateString("el-GR") : "—");
